/**
 * Admin > Enhanced DEMA-WMA Gainer v33 (TEK_DEMA_WMA_GAINER_V33_ENH): the same page as the original DEMA-WMA
 * Gainer, bound to the independent enhanced strategy's own API (own algo row, versions, positions, paper runner).
 */
import DemaWmaGainerPage from "./DemaWmaGainerPage";
import { enhancedDemaWmaGainerService } from "@/services/demaWmaGainerService";
import { DemaWmaServiceContext } from "@/services/demaWmaServiceContext";

export default function EnhancedDemaWmaGainerPage() {
  return (
    <DemaWmaServiceContext.Provider value={enhancedDemaWmaGainerService}>
      <DemaWmaGainerPage />
    </DemaWmaServiceContext.Provider>
  );
}
